import createEditSimProviderAccountRedux from 'Modules/simProviderAccounts/views/.components/createEditSimProviderAccount/redux/reducer';
import deleteSimProviderAccountRedux from 'Modules/simProviderAccounts/views/.components/deleteSimProviderAccount/redux/reducer';

//export redux objects
export default {
	createEditSimProviderAccountRedux,
	deleteSimProviderAccountRedux
};